import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Auth from './Auth';

const ProtectedRoute = ({ children, requireHost = false }) => {
  const { user, userProfile, loading, isHost } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#060010',
        color: '#ffffff'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!user || !userProfile) {
    return <Auth />;
  }

  if (requireHost && !isHost()) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#060010',
        color: '#ffffff',
        padding: '2rem'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center',
          maxWidth: '500px'
        }}>
          <h2 style={{ marginTop: 0 }}>Access Denied</h2>
          <p>You need to be a Host to access this page.</p>
          <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.875rem' }}>
            Only Hosts can create and manage games.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;

